import { Injectable, signal, effect } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    private readonly STORAGE_KEY = 'learn-monitoring-theme';

    readonly isDark = signal(this.getInitialTheme());

    constructor() {
        // Apply theme on init and whenever it changes
        effect(() => {
            this.applyTheme(this.isDark());
        });
    }

    private getInitialTheme(): boolean {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        if (stored !== null) {
            return stored === 'dark';
        }
        // Dark theme by default
        return true;
    }

    private applyTheme(isDark: boolean): void {
        const value = isDark ? 'dark' : 'light';
        // Taiga UI uses tuiTheme attribute
        document.documentElement.setAttribute('tuiTheme', value);
        document.body.setAttribute('tuiTheme', value);

        // Custom attribute for my styles (legacy support or extra specific overrides)
        document.documentElement.setAttribute('data-mode', isDark ? 'onDark' : 'onLight');

        document.body.classList.toggle('dark-theme', isDark);
        document.body.classList.toggle('light-theme', !isDark);
        localStorage.setItem(this.STORAGE_KEY, value);
    }

    toggle(): void {
        this.isDark.update(v => !v);
    }
}
